import { predictionAbi } from '@/libs/sdk/contracts/abis/prediction';
import { Log, parseEventLogs } from 'viem';

export type DepositFill = { amountIn: bigint; amountOut: bigint };
// sharesIn = option tokens sold, amountOut = base tokens received (after fee)
export type WithdrawFill = { sharesIn: bigint; amountOut: bigint };

const findMarketUserLog = <T extends 'Deposited' | 'Withdrawn'>(
  logs: Log[],
  eventName: T,
  marketAddress: string,
  user: string
) => {
  const parsed = parseEventLogs({ abi: predictionAbi, logs, eventName });
  return parsed.find(
    log => log.address.toLowerCase() === marketAddress.toLowerCase() && log.args.user.toLowerCase() === user.toLowerCase()
  );
};

// Exact fill from a buy receipt: the market's own Deposited(user, optionOut,
// amountIn, amountOut) log. Returns undefined when absent — the optimistic
// display path must never throw after a successful on-chain trade.
export const extractDepositFill = (logs: Log[], marketAddress: string, user: string): DepositFill | undefined => {
  try {
    const mine = findMarketUserLog(logs, 'Deposited', marketAddress, user);
    return mine ? { amountIn: mine.args.amountIn, amountOut: mine.args.amountOut } : undefined;
  } catch {
    return undefined;
  }
};

// Sell counterpart: Withdrawn(user, optionIn, amountIn, amountOut) where
// amountIn is the option-token (shares) amount sold.
export const extractWithdrawFill = (logs: Log[], marketAddress: string, user: string): WithdrawFill | undefined => {
  try {
    const mine = findMarketUserLog(logs, 'Withdrawn', marketAddress, user);
    return mine ? { sharesIn: mine.args.amountIn, amountOut: mine.args.amountOut } : undefined;
  } catch {
    return undefined;
  }
};
